import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthRoutes } from '../../../auth/routes/auth.routes';

const routes: Routes = [
  {
    path: AuthRoutes.authorize,
    loadComponent: () =>
      import('./views/authorize/mobile-authorize.component').then(
        m => m.MobileAuthorizeComponent
      ),
  },
  {
    path: '',
    redirectTo: '/auth/authorize',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MobileAuthRoutingModule {}
